export default __webpack_public_path__ + "static/media/save_bookmarks.1994ac27.svg";